import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor"

const messages = {
    required: "El campo {attribute} es requerido.",
    email: "Inserta una dirección de correo electrónico válida.",
    minLength: "Llenar los caracteres requeridos en campo {attribute}.",
    alpha: "Ingresa solamente letras en el campo {attribute}.",
    numeric: "Ingresa solamente numeros en el campo {attribute}.",
    maxLength: "Numero de caracteres invalido en campo {attribute}.",
    sameAs:"Los datos que ingresó son incorrectos."

  };

Vue.use(VuelidateErrorExtractor, {
    messages,
    attributes: {
      DateVal:"Fecha de nacimiento",
      name: "Nombre",
      lastname:"Apellido",
      email: "Email",
      text: "Text",
      phone:"Teléfono",
      dateBirth:"Fecha de nacimiento",
      password:"Contraseña",
      sterilized:"Esterilizado",
      vaccinated:"Vacunado",
      coexistAncient:"Convivencia",
      coexistLittleChill:"Convivencia",
      coexistAnimals:"Convivencia",
      sickness:"Enfermedades",
      allergies:"Alergias",
      notes:"Notas",
      race:"Raza",
      codeActivate:"Código de activación",
      codeValidation:"Código de validación"
    }
  });

Vue.use(Vuelidate)
Vue.component("formWrapper", templates.FormWrapper)
